<script>
import Form from './Form.svelte';
import LangSwitch from './LangSwitch.svelte';
import { _ } from 'svelte-intl';
import firebase from 'firebase/app';

export let date;

$: year = date.substr(0,4);
$: day = date.substr(8,2);
$: month = $_(`date.months.${date.substr(5,2)}`);
$: lastDayDigit = (day === '11' || day === '12') ? day : date.substr(9,1);
$: daySuffix = $_(`date.daySuffix.${lastDayDigit}`);

firebase.analytics().logEvent('open_form', { date });
</script>

<div class="container">
  <LangSwitch />

  <div class="top">
    <img src="/images/logo.png" class="logo" alt="Esch 2022 Logo">
    <h1>
      {@html $_('title')}<br>
      {$_('titleOn')}
      {@html $_('date.format', { day, daySuffix, month, year })}
    </h1>
  </div>

  <Form {date}/>

  <div class="linksFooter">
    <a href="{$_('docs.privacy-policy.link')}" target="_blank">{$_('docs.privacy-policy.title')}</a> 
    <a href="{$_('docs.notice.link')}" target="_blank">{$_('docs.notice.title')}</a> 
    <a href="{$_('docs.terms.link')}" target="_blank">{$_('docs.terms.title')}</a>
  </div>
</div>

<style>
.container {
  max-width: 1200px;
  margin: auto;
  padding: 0 2rem;
}

.logo {
  width: 205px;
  height: 37px;
}

.top {
  text-align: center;
  padding-top: 6rem;
  animation: animTop 0.8s cubic-bezier(.36,.62,.53,1.13) forwards;
  will-change: transform;
}


@keyframes animTop {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

h1 {
  font-size: 3.4rem;
  color: #ffffff;
  font-weight: 700;
  line-height: 1.4;
}

h1 :global(sup) {
  font-size: 1.6rem;
}


.linksFooter {
  margin-top: 5rem;
  text-align: center;
}

.linksFooter a {
  font-size: 1.6rem;
  color: #ffffff;
  font-weight: 500;
  display: inline-block;
  margin: 0 1rem;
  text-decoration: none;
}

@media(max-width: 767px) {
  .top {
    padding-top: 9rem;
  }
  
  h1 {
    font-size: 2.4rem;
  }

  .linksFooter {
    margin-bottom: 5rem;
  }

  .linksFooter a {
    display: block;
    margin: 2rem 1rem;
  }
}

</style>